/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';
import { Content } from '../../../../../apiServices/contentService';
import Card, { EmptyCard } from '../../../../components/card/Card';
import { GroupThemeMarkdown } from '../../../../components/Markdown';
import { withLanguageCode } from '../../../../../utilities/localizedUtil';
import PreformattedText from '../../../../components/PreformattedText';

interface Props {
  resources: Content[];
  languageCode: string;
  group: any;
}

@withLanguageCode
export class GroupResources extends React.Component<Props, {}> {
  render() {
    const { resources, languageCode, group } = this.props;
    const { body } = resources[0];
    const orgName = group.organization_name.i18n[languageCode] || group.organization_name.default;

    return (
      <div>
        <Card hasMargins={false} style={{ marginBottom: 16 }}>
          <div className="util-application-card-padding">
            <div style={{ paddingTop: 16, paddingBottom: 16 }}>
              <GroupThemeMarkdown text={body.i18n[languageCode] || body.default} />
            </div>
          </div>
        </Card>

        <EmptyCard>
          <PreformattedText
            className="font-color-gsMedDark"
            text="group.resources.disclaimer.pre"
            textValues={{ string1: orgName }}
          />
        </EmptyCard>
      </div>
    );
  }
}
